import { makeAutoObservable } from "mobx";  
import { Subject } from "rxjs";  
import { IAPIPaginationResponse, PaginationModel } from "@mindmemobile/mm-shared-global";
import { OrdersGridModel } from "../models/OrdersGridModel";
import { OrderDetailPageModel } from "../models/OrderDetailPageModel";
import { IAPIOrdersGridModel } from "../interfaces/IAPIOrderModels";

export default class OrderStore {
  public searchValue: string = '';
  public gridData: OrdersGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel({ pageNumber: 1, pageSize: 10 });
  public searchSubject = new Subject<boolean>();
  public detailPage: OrderDetailPageModel = new OrderDetailPageModel();
  public showFilter: boolean = false;
  constructor() {
      makeAutoObservable(this);
  }

  deserializeAPIResponse(data: IAPIOrdersGridModel[], pagination: IAPIPaginationResponse): void {
      this.gridData = (data && data.map((order: any) => OrdersGridModel.deserializeAPIModel(order))) || [];
      this.pagination = PaginationModel.deserialize(pagination);
  }

  updateSearchValue(value: string): void {
      this.searchValue = value;
      this.searchSubject.next(true);
  }

  toggleFilter(): void {
      this.showFilter = !this.showFilter;
  }

  updateDetailPageContent(): void {}
}
